let menuLoaded = false;
async function loadMenu() {
  if (menuLoaded) return;
  const response = await fetch('/pages/collection');
  const html = await response.text();
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const menuDiv = doc.getElementById('mega-menu-container');
  //console.log(menuDiv?.innerHTML);
  document
      .querySelector('#header-menu ul.list-menu')
      .insertAdjacentHTML('afterbegin', menuDiv.innerHTML);
  menuLoaded = true;

  let items = document.querySelector(".header__inline-menu").querySelectorAll("details");  
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
  });
  
const menu = document.getElementById('header-menu');
document.addEventListener('click', (event) => {
    if (!menu.contains(event.target)) {
         items.forEach(item => {
           item.removeAttribute("open");
          });  
    }
});

}
loadMenu();